import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import SidePane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import UnifiedImagePicker from "../../../cms/media-picker/unified-image-picker.jsx";
import { setAvator, openAddLpModal } from '../landing-page-action.js';

class UploadProfileImage extends PureComponent {
  toggleModal = () => {
    this.props.lpType === 'ADD' ?
      this.props.openAddLpModal() :
      this.props.PASTECARDID()
    this.props.closePisco()
    this.props.setLpType(null)
  }
  render() {
    return (
      <Fragment>
        <SidePane
          overlayClassName='pisco-pane'
          isOpen={this.props.showPiscoModal}
          title='MEDIA'
          subtitle='Media Search'
          from='right'
          width='80%'
          onRequestClose={this.toggleModal}
        >
          <UnifiedImagePicker
            endpoint={process.env.REACT_APP_API_SERVER}
            headers={{ authorization: localStorage.getItem('accessToken') }}
            injectQuery={{ domainId: this.props.activeDomain }}
            activeDomain={this.props.activeDomain}
            type={"Image"}
            uploadId={"profile-" + this.props.activeDomain}
            uploadNote={<span>Upload a profile image. It is <strong>not</strong> saved to the Media Library or Pisco.</span>}
            onEmbed={content => {
              this.props.setAvator(content.cdn)
              this.toggleModal()
            }}
            onClose={this.toggleModal}
          />
        </SidePane>
      </Fragment>

    );
  }
}
const mapStateToProps = (state) => {
  const {
    login: { user },
    tool: { landingPages: { landingPageSetting: { type } } }
  } = state;
  return {
    activeDomain: user.activeDomain,
    type
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setAvator: (avator) => dispatch(setAvator(avator)),
    openAddLpModal: () => dispatch(openAddLpModal()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(UploadProfileImage);
